import cookie from "react-cookies";
import moment from 'moment-timezone';

/**
 *@param name {string}
 *@param value {string|Object}
 *@param time {number}
 *@param timeFormat {string} =>  y:year, M:month, d:day, h:hour, m:minute, s:second, ms:millisecond
 * */
export function saveCookie(name, value, time = 30, timeFormat = 'd') {
    const expires = new Date(moment().utc(false).tz('Asia/Tehran').add(time, timeFormat).format());

    cookie.save(name, value, {
        expires: expires,
        secure: false,
        httpOnly: false,
        path: '/'
    });
}
